export default {
  name: 'Loading',
  props: {
    loading: {
      type: [Boolean, Number],
      default: false
    }
  }
};